<template>
    <Teleport defer to="#tx-toast-container">
        <TransitionGroup name="toast">
            <toastItem v-for='c in messages' :key="c.id" :text="c.text" :duration="c.duration" :id="c.id"
            @close="handleClose" />
        </TransitionGroup>
    </Teleport>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import eventEmitter from '@utils/event'
import toastItem from './toastItem.vue';
var messages = ref([])
var count = ref(1)
function handleClose(id) {
    messages.value = messages.value.filter((item) => {
        return item.id != id
    })
}
onMounted(() => {
    eventEmitter.on('toast', (data) => {
        data.id = count.value++ + ''
        if (!data.duration) {
            data.duration = 1
        }
        if(messages.value.length>=5){
            messages.value.shift()
        }
        messages.value.push(data)
    })
    
})
</script>